export class Page<T> {
  constructor(public metadata: { count: number, page: number, pages: number },
              public content?: T[]) {
  }
}
